export function watchConnectivity(cb) {
    if (typeof window === "undefined")
        return () => undefined;
    const emit = () => cb({ online: navigator.onLine });
    window.addEventListener("online", emit);
    window.addEventListener("offline", emit);
    document.addEventListener("visibilitychange", () => document.visibilityState === "visible" && emit());
    emit();
    return () => {
        window.removeEventListener("online", emit);
        window.removeEventListener("offline", emit);
    };
}
//# sourceMappingURL=connectivity.js.map